import React from "react";
import { View } from "react-native";
import styles from "./CatalogStyle";

export const CatalogDivider = () => {
  return <View style={styles.catalogDivider} />;
};
